import React from 'react';
import { Globe, Users, DollarSign, Briefcase, Shield, MapPin } from 'lucide-react';

const WhyDubai = () => {
  const reasons = [
    {
      icon: Globe,
      title: 'Globally Recognised Universities',
      description: 'Study in Dubai and earn internationally accredited degrees from leading universities from the US, UK, Australia, and many more - blending global education with Dubai\'s thriving career landscape.'
    },
    {
      icon: Users,
      title: 'Multicultural Environment',
      description: 'Learn alongside students from over 200+ nationalities and build a truly global network that lasts a lifetime.'
    },
    {
      icon: DollarSign,
      title: 'Affordable Quality Education',
      description: 'High-quality courses and world-class facilities without breaking the bank.'
    },
    {
      icon: Briefcase,
      title: 'Career Opportunities',
      description: 'Get a head start on your career with job opportunities, internships, industry events, and real-world projects - all while you\'re still on campus.'
    },
    {
      icon: Shield,
      title: 'Safe and Student-Friendly City',
      description: 'Consistently ranked among the safest cities globally, Dubai ensures students feel secure, supported, and at home.'
    },
    {
      icon: MapPin,
      title: 'Perfectly Connected Location',
      description: 'Travel, explore, and experience Dubai - a city at the crossroads of cultures, business, and innovation.'
    }
  ];

  return (
    <>
      <section id="why-dubai" className="why-dubai-section">
        <div className="why-dubai-container">
          <div className="why-dubai-content-wrapper">
            <div className="why-dubai-text-content">
              <div className="why-dubai-header">
                <h2 className="section-title">Why Students Choose Dubai</h2>
              </div>

              <div className="why-dubai-grid">
                {reasons.map((reason, index) => (
                  <div key={index} className="why-dubai-card">
                    <div className="why-dubai-icon">
                      <reason.icon size={28} />
                    </div>
                    <h3 className="why-dubai-title">{reason.title}</h3>
                    <p className="why-dubai-description">{reason.description}</p>
                  </div>
                ))}
              </div>
            </div>
            <div className="why-dubai-image">
              <img 
                src="https://customer-assets.emergentagent.com/job_dubai-education/artifacts/pttnav0u_Dubai-pana.png" 
                alt="International students exploring Dubai skyline and iconic landmarks while studying abroad"
                className="why-dubai-illustration"
              />
            </div>
          </div>
        </div>
      </section>
      <div className="wave-divider">
        <svg viewBox="0 0 1200 120" preserveAspectRatio="none">
          <path d="M321.39,56.44c58-10.79,114.16-30.13,172-41.86,82.39-16.72,168.19-17.73,250.45-.39C823.78,31,906.67,72,985.66,92.83c70.05,18.48,146.53,26.09,214.34,3V0H0V27.35A600.21,600.21,0,0,0,321.39,56.44Z" fill="#9fe2ff"></path>
        </svg>
      </div>
    </>
  );
};

export default WhyDubai;